import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

export const FiDocumentStatesResolvePageTitle = [
    PageTitleService,
    'document',
    FiDocumentStatesResolvePageTitleResolveFunc,
];

export function FiDocumentStatesResolvePageTitleResolveFunc(pageTitleService: PageTitleService, document) {
    return pageTitleService.setTitleByItem(document);
}
